<!--
 * @Author: yuanjianlong
 * @Description: 公共头部
 * @Date: 2021-11-29 16:44:45
 * @LastEditTime: 2022-03-23 15:54:52
 * @FilePath: /teacher-h5/src/components/ComHeader.vue
-->
<template>
  <ComHeaderLeft>
    <span :class="[isSupervision ? 'full-btn-style-black' : 'full-btn-style-white']">
      <span class="scaling" v-if="isSupervision && scaling < 100">
        <a-icon @click="minusScaling" class="scaling-minus" :style="{color: scalingNum <= scaling ? '#98A2B2' : ''}" type="minus" />
        <span class="num">{{ scalingNum }}%</span>
        <a-icon @click="plusScaling" class="scaling-plus" :style="{color: scalingNum === 100 ? '#98A2B2' : ''}" type="plus" />
        <a-divider
          class="divider-style"
          type="vertical"
          style="margin: 0 0 0 20px;"
        />
      </span>
      <span @click="toggleFullScreen">
        <a-icon type="fullscreen" v-if="!isFullScreen" />
        <a-icon type="fullscreen-exit" v-else />
        {{ !isFullScreen ? '全屏' : '还原' }}
      </span>
      <a-divider
        class="divider-style"
        type="vertical"
        style="margin: 0 0 0 17px;"
      />
    </span>

    <span class="system-time" v-show="$route.path==='/supervisionCourse/list' && getSysTemTime" :style="{color: '#fff'}">
      <SvgIcon icon="clock" class="clock-icon" />
      <span class="time">{{ getSysTemTime }}</span>
      <a-divider
        class="divider-style"
        type="vertical"
        style="margin: 0 20px 0 7px;"
      />
    </span>

    <div class="header-right" id="dropdown-parent" v-if="$route.name !== 'login' && userInfo">
      <a-dropdown @visibleChange="visibleChange" placement="bottomRight" :get-popup-container="getPopupContainer">
        <div class="right-userinfo" @click="e => e.preventDefault()">
          <img class="user-avatar" :src="teacherPortraitPath" alt="老师头像" />
          <span class="teacher-name p14" :style="{color: $route.path !== '/supervisionCourse/list' ? '#303858' : '#fff'}">{{ userInfo.teacherName }}</span>
          <i class="iconfont" :class="{'icon-down': !visible, 'icon-up': visible}" :style="{color: isSupervision ? '#fff': ''}" />
        </div>
        <div slot="overlay">
          <div class="user-info-detail">
            <div class="detail-top">
              <div class="user-name mb-4">
                <img class="user-avatar" :src="teacherPortraitPath" alt="老师头像" />
                <span class="teacher-name h14">{{ userInfo.teacherName }}</span>
              </div>
              <span class="ins-name p12 mb-4">机构：{{ userInfo.institutionName }}</span>
              <span class="ins-name p12 mb-4">账号：{{ userInfo.teacherPhone }}</span>
              <span class="user-id p12 mb-4">ID：{{ userInfo.userId }}</span>
            </div>
            <ul class="detail-bottom">
              <!-- <li class="detail-item" @click="handleClickUserProtocol">
                用户服务协议
              </li>
              <li class="detail-item" @click="handleClickPrivacyPolicy">
                隐私协议
              </li> -->
              <li class="detail-item" @click="handleLogout">
                退出账号
              </li>
            </ul>
          </div>
        </div>
      </a-dropdown>
    </div>
    <user-protocol :visible.sync="userProtocolVisible" />
    <privacy-policy :visible.sync="privacyPolicyVisible" />
  </ComHeaderLeft>
</template>

<script>
import UserProtocol from '@/components/UserProtocol'
import PrivacyPolicy from '@/components/PrivacyPolicy'
import ComHeaderLeft from '@/components/ComHeaderLeft'
import { getToken, removeToken } from '@/utils/tools'
import { EventBus } from '@/views/studentManage/studentAndGroup/studentDetails/event-bus'
import Moment from 'moment'
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'ComHeader',

  components: {
    UserProtocol,
    PrivacyPolicy,
    ComHeaderLeft
  },
  data() {
    return {
      visible: false,
      userProtocolVisible: false,
      privacyPolicyVisible: false,
      // userInfo: null,
      systemTime: null,
      timer: null,
      scaling: this.computedScaling(),
      stepNum: 10 // 步长
    }
  },
  watch: {
    '$route.path': {
      handler(v) {
        console.log(this.isFullScreen)
        if (v !== '/supervisionCourse/list') {
          this.clearTimer()
          // 非监课页面设置缩放比例100
          this.setScalingNum(100)
        } else {
          // 监课切其他页面又切回时，保留用户操作的缩放比例
          const userOperationNum = sessionStorage.getItem('userOperationNum')
          const num = Number(userOperationNum) ? Number(userOperationNum) : this.scaling
          this.setScalingNum(num)
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      isFullScreen: 'common/isFullScreen',
      scalingNum: 'common/scalingNum',
      userInfo: 'userInfo/userInfo'
    }),
    isSupervision () {
      return this.$route.path === '/supervisionCourse/list'
    },
    getSysTemTime() {
      if (!this.systemTime) return false
      return Moment(this.systemTime).format('YYYY/MM/DD HH:mm:ss')
    },
    teacherPortraitPath() {
      const { userInfo } = this
      if (userInfo && userInfo.teacherPortraitPath) {
        return userInfo.teacherPortraitPath
      }
      return '//image.aixuexi.com/default.jpg'
    }
  },
  mounted() {
    // this.getLoginInfo()
    EventBus.$on('systemTime', v => {
      this.systemTime = v
      this.clearTimer()
      this.timer = setInterval(() => {
        this.systemTime += 1000
      }, 1 * 1000)
    })

    window.addEventListener('resize', () => {
      var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement
      this.$nextTick(() => {
        if (fullscreenElement) {
          this.setIsFullScreen(true)
        } else {
          this.setIsFullScreen(false)
        }
      })
    })
  },
  methods: {
    ...mapMutations({
      setIsFullScreen: 'common/setIsFullScreen',
      setScalingNum: 'common/setScalingNum'
    }),
    computedScaling() {
      // 缩放比例计算： 屏宽/设计尺寸
      const num = Number((window.screen.width / 1920 * 100).toFixed())
      console.log('num', num)
      return num
    },
    getPopupContainer() {
      return document.getElementById('dropdown-parent')
    },
    minusScaling() {
      if (this.scalingNum === this.scaling) return
      if (this.scalingNum > this.scaling && (this.scalingNum - this.scaling) < this.stepNum) {
        const num = this.scaling
        this.setScalingNum(num)
      } else {
        const num = this.scalingNum -= this.stepNum
        this.setScalingNum(num)
      }
    },
    plusScaling() {
      if (this.scalingNum >= 100) return
      if (this.scalingNum < 100 && (this.scalingNum + this.stepNum) > 100) { // 递增大于100按100处理
        const num = 100
        this.setScalingNum(num)
      } else {
        const num = this.scalingNum += this.stepNum
        this.setScalingNum(num)
      }
    },
    toggleFullScreen() {
      this.setIsFullScreen(!this.isFullScreen)
      this.isFullScreen ? this.fullScreen() : this.exitFullscreen()
    },
    fullScreen() {
      var de = document.documentElement
      if (de.requestFullscreen) {
        de.requestFullscreen()
      } else if (de.msRequestFullScreen) {
        de.msRequestFullScreen()
      } else if (de.mozRequestFullScreen) {
        de.mozRequestFullScreen()
      } else if (de.webkitRequestFullScreen) {
        de.webkitRequestFullScreen()
      }
    },
    exitFullscreen() {
      try {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        }
      } catch (err) {
        console.info(err)
      }
    },
    clearTimer () {
      window.clearInterval(this.timer)
      this.timer = null
    },
    // async getLoginInfo() {
    //   const userInfo = await this.$service.login.getLogininfo()
    //   this.userInfo = userInfo
    //   this.$store.commit('userInfo/setUserInfo', userInfo)
    // },
    visibleChange(visible) {
      this.visible = visible
    },
    handleLogout() {
      this.$confirm({
        content: '您确认退出登录吗？',
        okText: '退出',
        cancelText: '取消',
        centered: true,
        onOk: () => {
          this.logout()
        }
      })
    },
    /**
     * 退出登录
     */
    logout() {
      const token = getToken()
      const data = {
        token
      }
      this.$service.login.logout(data)
        .then(() => {
          removeToken()
          this.$store.commit('userInfo/setUserInfo', {})
          this.$router.push({
            path: '/login'
          })
        })
    },
    handleClickUserProtocol() {
      this.userProtocolVisible = true
    },
    handleClickPrivacyPolicy() {
      this.privacyPolicyVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/static/css/base.less';
.divider-style {
    background: #505873;
    height: 20px;
}
.system-time {
  display: inline-block;
  position: relative;
  top: 3px;
  font-family: 'Microsoft YaHei UI';
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.04em;
  .time {
    display: inline-block;
    min-width: 153px;
  }
  .clock-icon {
    position: absolute;
    left: -18px;
    top: 3px;
    font-size: 14px;
    fill: #fff
  }
}
.scaling {
  margin-right: 24px;
  .scaling-minus {
    font-size: 16px;
  }
  .scaling-plus {
    font-size: 16px;
  }
  .num {
    margin: 0 14px;
    display: inline-block;
    min-width: 28px;
    text-align: center;
  }
}
.full-btn-style-black {
  display: inline-block;
  vertical-align: sub;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.04em;
  color: #fff;
  margin-right: 40px;
  cursor: pointer;
}
.full-btn-style-white {
  display: inline-block;
  vertical-align: sub;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.04em;
  color: #313956;
  margin-right: 25px;
  cursor: pointer;
}
.header-right {
  height: 100%;
  float: right;
  position: relative;
  cursor: pointer;
  color: #303858;
  .right-userinfo {
    display: flex;
    align-items: center;
    height: 100%;

    .user-avatar {
      width: 24px;
      height: 24px;
      border-radius: 24px;
    }
    .teacher-name {
      margin: 0 8px;
    }

    .iconfont {
      font-size: 18px;
    }
  }

}
.user-info-detail {
  width: 200px;
  background: @gray-10;
  box-shadow: 0px 2px 4px rgba(40, 41, 61, 0.04), 0px 8px 16px rgba(96, 97, 112, 0.16);
  border-radius: 6px;
  .detail-top {
    display: flex;
    flex-direction: column;
    padding: 20px 20px 0 20px;

    .mb-4 {
      margin-bottom: 4px;
    }
    .user-avatar {
      width: 24px;
      height: 24px;
      border-radius: 4px;
    }

    .user-name {
      display: flex;
      align-items: center;
    }

    .teacher-name {
      color: @gray-1;
      margin-left: 8px;
    }

    .ins-name, .user-id {
      color: @gray-4;
    }
  }

  .detail-bottom {
    margin-top: 12px;

    .detail-item {
      height: 32px;
      padding-left: 20px;
      font-size: 12px;
      line-height: 32px;
      color: @gray-1;
      border-top: 1px solid @gray-7;
      cursor: pointer;
    }
  }
}
</style>